import React, { useEffect } from 'react'

import { useHistory, useLocation, Link } from 'react-router-dom'
// import LogoutIcon from '../../assests/images/logout.svg'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import Logo from '../../assests/images/logo-dark.png';
// import UserProfile from '../../assests/images/faces/face1.jpg';
import { S3_BUCKET_URL } from '../../config/HttpService'
const Header = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const code = queryParams.get('code')
    if (code) {
      history.push({
        pathname: '/dropboximagesync',
        search: `code=${code}`
      })
    }
  }, [])

  // remove user from local storage to log user out
  const logout = (e) => {
    e.preventDefault()
    localStorage.removeItem('appState')
    localStorage.removeItem('PermissionList')
    window.location.href = '/login'
  }

  return (
    <>
      <header>
        <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
          <div className="navbar-menu-wrapper d-flex align-items-stretch">
            <button
              className="navbar-toggler navbar-toggler align-self-center"
              type="button"
              data-toggle="minimize"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#c394a8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-left"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
              <Link
                className="navbar-brand brand-logo-mini"
                to="/"
              >
                <img
                  src={S3_BUCKET_URL + 'assests/images/logo-dark.png'}
                  width="79px"
                  alt="logo"
                />
              </Link>
            </div>
            <ul className="navbar-nav navbar-nav-right">
              <li className="nav-item dropdown">
                <a
                  className="nav-link"
                  id="messageDropdown"
                  href="#"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="mdi mdi-email-outline"></i>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-left navbar-dropdown preview-list"
                  aria-labelledby="messageDropdown"
                >
                  <h6 className="p-3 mb-0 font-weight-semibold">Messages</h6>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item preview-item">
                    <div className="preview-thumbnail">
                      <img
                        src={S3_BUCKET_URL + 'assets/images/faces/face1.jpg'}
                        alt="image"
                        className="profile-pic"
                      />
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                        Mark send you a message
                      </h6>
                      <p className="text-gray mb-0"> 1 Minutes ago </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item preview-item">
                    <div className="preview-thumbnail">
                      <img
                        src={S3_BUCKET_URL + 'assets/images/faces/face1.jpg'}
                        alt="image"
                        className="profile-pic"
                      />
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                        Cregh send you a message
                      </h6>
                      <p className="text-gray mb-0"> 15 Minutes ago </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item preview-item">
                    <div className="preview-thumbnail">
                      <img
                        src={S3_BUCKET_URL + 'assets/images/faces/face1.jpg'}
                        alt="image"
                        className="profile-pic"
                      />
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                        Profile picture updated
                      </h6>
                      <p className="text-gray mb-0"> 18 Minutes ago </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <h6 className="p-3 mb-0 text-center text-primary font-12">4 new messages</h6>
                </div>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link"
                  id="notificationDropdown"
                  href="#"
                  data-toggle="dropdown"
                >
                  <i className="mdi mdi-bell-outline"></i>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-left navbar-dropdown preview-list"
                  aria-labelledby="notificationDropdown"
                >
                  <h6 className="px-3 py-3 font-weight-semibold mb-0">Notifications</h6>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item preview-item">
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-success">
                        <i className="mdi mdi-calendar"></i>
                      </div>
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject font-weight-normal mb-0">
                        New order recieved
                      </h6>
                      <p className="text-gray ellipsis mb-0"> 45 sec ago </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item preview-item">
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-warning">
                        <i className="mdi mdi-settings"></i>
                      </div>
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject font-weight-normal mb-0">
                        Server limit reached
                      </h6>
                      <p className="text-gray ellipsis mb-0"> 55 sec ago </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item preview-item">
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-info">
                        <i className="mdi mdi-link-variant"></i>
                      </div>
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject font-weight-normal mb-0">Kevin karvelle</h6>
                      <p className="text-gray ellipsis mb-0"> 11:09 PM </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <h6 className="p-3 font-13 mb-0 text-primary text-center">
                    View all notifications
                  </h6>
                </div>
              </li>
              <li
                className="nav-item nav-logout d-none d-lg-block"
                title="Logout"
              >
                <Link
                  className="nav-link"
                  to=""
                  onClick={logout}
                >
                  <img
                    src={S3_BUCKET_URL + 'assets/images/logout.svg'}
                    alt="logout"
                  />
                </Link>
              </li>
            </ul>
            <button
              className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
              type="button"
              data-toggle="offcanvas"
            >
              <span className="mdi mdi-menu"></span>
            </button>
          </div>
        </nav>
        <ToastContainer />
      </header>
    </>
  )
}

export default Header
